import axiosInstance from './axiosConfig';

// Kullanıcının tüm aktivitelerini getir
export const getMyActivities = async () => {
  try {
    const response = await axiosInstance.get('/activities/my');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Kullanıcının aktif aktivitelerini getir (Onaylanmış)
export const getMyActiveActivities = async () => {
  try {
    //console.log('getMyActiveActivities çağrıldı');
    // API'den tüm aktiviteleri getir - activityType detaylarını da alalım
    const response = await axiosInstance.get('/activities/my?include=activityType');
    //console.log('API Yanıtı:', JSON.stringify(response.data, null, 2));
    
    if (response.data.success && response.data.data) {
      // end_time null olanlar ve status Active olanlar aktif
      const activeActivities = response.data.data.filter(activity => {
        const isActive = activity.end_time === null && activity.status === 'Active';
        //console.log(`Aktivite ID: ${activity.id}, end_time: ${activity.end_time}, status: ${activity.status}, isActive: ${isActive}`);
        return isActive;
      });
      
      //console.log(`Filtreleme sonrası ${activeActivities.length} aktif aktivite bulundu`);
      return { ...response.data, data: activeActivities };
    }
    
    //console.log('API başarısız veya veri yok');
    return response.data;
  } catch (error) {
    console.error('getMyActiveActivities hata:', error);
    throw error.response?.data || error.message;
  }
};

// Onay bekleyen aktivitelerimi getir (sadece frontend üzerinde filtreleme)
export const getMyPendingActivities = async () => {
  try {
    const response = await getMyActivities();
    
    if (response.success && response.data) {
      // Sadece "WaitingForApproval" durumundaki aktiviteleri filtrele
      const pendingActivities = response.data.filter(activity => 
        activity.status === 'WaitingForApproval'
      );
      
      return {
        success: true,
        data: pendingActivities,
        message: 'Onay bekleyen aktiviteler başarıyla getirildi'
      };
    }
    
    return response;
  } catch (error) {
    console.error('Onay bekleyen aktiviteleri getirirken hata:', error);
    return {
      success: false,
      message: error.message || 'Aktiviteler yüklenirken bir hata oluştu'
    };
  }
};

// Belirli bir çocuğa ait aktiviteleri getir
export const getChildActivities = async (childId) => {
  try {
    const response = await axiosInstance.get(`/activities/child/${childId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ID'ye göre aktivite detaylarını getir
export const getActivityById = async (activityId) => {
  try {
    const response = await axiosInstance.get(`/activities/${activityId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Yeni aktivite oluştur
export const createActivity = async (activityData) => {
  try {
    //console.log('createActivity çağrıldı, gelen veri:', JSON.stringify(activityData, null, 2));
    
    // Backend API'nin beklediği parametrelere dönüştür
    const apiData = {
      child_id: activityData.childId, 
      activity_type_id: activityData.activityType === 'oyun-parki' ? 1 : activityData.activityType,
      start_time: activityData.startTime,
      notes: activityData.notes
    };
    
    //console.log('API için dönüştürülen veri:', JSON.stringify(apiData, null, 2));
    
    const response = await axiosInstance.post('/activities', apiData);
    //console.log('API yanıtı:', JSON.stringify(response.data, null, 2));
    
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error.message);
    throw error.response?.data || error.message;
  }
};

// Aktiviteyi tamamla
export const completeActivity = async (activityId) => {
  try {
    const response = await axiosInstance.put(`/activities/complete/${activityId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Aktivite tiplerini getir
export const getActivityTypes = async () => {
  try {
    const response = await axiosInstance.get('/activities/types');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Onay bekleyen aktiviteyi iptal et
export const cancelPendingActivity = async (activityId) => {
  try {
    const response = await axiosInstance.post(`/activities/cancel/${activityId}`);
    return response.data;
  } catch (error) {
    console.error('Aktivite iptal edilirken hata:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Aktivite iptal edilirken bir hata oluştu'
    };
  }
};

// Aktivite durumuna göre bilgileri döndüren yardımcı fonksiyon
export const getActivityStatusInfo = (status) => {
  // Statü bilgisi yoksa
  if (!status) {
    return { label: 'Bilinmiyor', color: '#9E9E9E', textColor: '#424242', icon: 'help-circle' };
  }
  
  // Mevcut durumlar için bilgiler
  switch(status) {
    case 'Active':
      return { label: 'Aktif', color: '#4CAF50', textColor: '#1b5e20', icon: 'run' };
    case 'Completed':
      return { label: 'Tamamlandı', color: '#3F51B5', textColor: '#1a237e', icon: 'check-circle' };
    case 'WaitingForApproval':
      return { label: 'Onay Bekliyor', color: '#FF9800', textColor: '#e65100', icon: 'clock-outline' };
    case 'Cancelled':
      return { label: 'İptal Edildi', color: '#F44336', textColor: '#b71c1c', icon: 'cancel' };
    default:
      return { label: status, color: '#9E9E9E', textColor: '#424242', icon: 'help-circle' };
  }
};
